<mat-form-field appearance="fill">
  <mat-label>Select Percentile</mat-label>
  <mat-select [(value)]="selectedMedian" (selectionChange)="setMedian($event.value)">
    <mat-option *ngFor="let median of medians; trackBy: trackById" [value]="median">
      <ng-template [ngIf]="median === 0">
        All
      </ng-template>
      <ng-template [ngIf]="median > 0"> {{ median * 100 }}th </ng-template>
    </mat-option>
  </mat-select>
  <mat-hint>{{ hintText }}</mat-hint>
</mat-form-field>
